import Vue from 'vue'
import VueI18n from 'vue-i18n'
import i18nInit from './init'

const i18n = i18nInit(Vue, VueI18n);

export default i18n;
